import React from "react";
import { ClipboardList, Database, Trash2, X } from "lucide-react";
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import CdrStagingRecordsList from "@/components/cdr/CdrStagingRecordsList";

const CdrStagingViewModal = ({
  open,
  onClose,
  items,
  isDark,
  labelClass,
  textClass,
  cardClass,
  onRemove,
  onClear,
  onPlay,
}) => {
  const panelClass = isDark ? "bg-slate-900 border-slate-700 text-white" : "";

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className={`max-w-6xl max-h-[92vh] overflow-hidden flex flex-col p-0 gap-0 ${panelClass}`}>
        <DialogHeader className="px-5 pt-5 pb-3 border-b shrink-0">
          <DialogTitle className={`text-base flex items-center gap-2 ${textClass}`}>
            <ClipboardList className="w-5 h-5 text-violet-500" />
            CDR Sepeti
          </DialogTitle>
          <p className={`text-xs mt-1 ${labelClass}`}>
            Ana sayfada sepete eklediğiniz çağrı kayıtları. Takım lideri ses kayıtlarında + ile bu listeyi kullanabilirsiniz.
          </p>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto min-h-0 p-4 sm:p-5">
          <Card className={cardClass || (isDark ? "bg-slate-900/60 border-slate-800" : "bg-white border-gray-200")}>
            <CardHeader className="p-[1.1rem] space-y-0 flex flex-row items-center justify-between gap-2">
              <CardTitle className={`text-base font-semibold flex flex-wrap items-center gap-1.5 ${textClass}`}>
                Çağrı Kayıtları
                {items.length > 0 && (
                  <span className={`text-xs font-medium px-2 py-0.5 rounded-full tabular-nums ${
                    isDark ? "bg-indigo-500/15 text-indigo-300 border border-indigo-500/25" : "bg-indigo-50 text-indigo-700 border border-indigo-200"
                  }`}>
                    {items.length.toLocaleString("tr-TR")} kayıt
                  </span>
                )}
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              {items.length === 0 ? (
                <div className={`text-center py-16 ${labelClass}`}>
                  <Database className="w-12 h-12 mx-auto mb-3 opacity-30" />
                  <p>Sepette kayıt yok</p>
                </div>
              ) : (
                <CdrStagingRecordsList
                  items={items}
                  isDark={isDark}
                  labelClass={labelClass}
                  textClass={textClass}
                  onRemove={onRemove}
                  onPlay={onPlay}
                />
              )}
            </CardContent>
          </Card>
        </div>

        <DialogFooter className={`shrink-0 border-t px-5 py-4 gap-2 ${isDark ? "border-slate-800" : "border-gray-200"}`}>
          <Button
            type="button"
            variant="outline"
            disabled={!items.length}
            onClick={onClear}
            className={isDark ? "border-rose-500/40 text-rose-300 hover:bg-rose-950/40" : "border-rose-300 text-rose-700 hover:bg-rose-50"}
          >
            <Trash2 className="w-4 h-4 mr-1" /> Sepeti temizle
          </Button>
          <Button type="button" variant="ghost" onClick={onClose}>
            <X className="w-4 h-4 mr-1" /> Kapat
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CdrStagingViewModal;
